<div class="text-danger small"
     *ngIf="form.get(inputName).hasError(error) && form.get(inputName).touched"
     >{{ text | translate }}
</div>
